export enum OriginLoadingEnum {
  SEARCH = 'busca',
  CATEGORY = 'categoria',
}
